<template>
	<!--
		Off the feature this renders the slot bare, so the other templates keep
		byte-identical markup. `contents` keeps the wrapper out of the parent
		flex/grid when the gate is active.
	-->
	<slot v-if="!b2bAccess" />
	<div v-else-if="!isPriceHidden" data-testid="price-gate" class="contents">
		<slot />
	</div>
</template>

<script setup lang="ts">
const { b2bAccess, isPriceHidden } = usePriceVisibility();
</script>
